import { useEffect } from 'react'
import { useMedia } from './useMedia'

/**
 * Links de ancora rolam suave, descontando a altura do cabecalho fixo —
 * sem isso o titulo da secao para escondido atras dele.
 */
export function useSmoothScroll() {
  const { reduced } = useMedia()

  useEffect(() => {
    const aoClicar = (e: MouseEvent) => {
      const alvo = e.target as HTMLElement | null
      const link = alvo?.closest<HTMLAnchorElement>('a[href^="#"]')
      if (!link) return

      const id = link.getAttribute('href')
      if (!id || id === '#' || id.length < 2) return

      const destino = document.querySelector(id)
      if (!destino) return

      e.preventDefault()
      window.scrollTo({
        top: destino.getBoundingClientRect().top + window.pageYOffset - 68,
        behavior: reduced ? 'auto' : 'smooth',
      })
    }

    document.addEventListener('click', aoClicar)
    return () => document.removeEventListener('click', aoClicar)
  }, [reduced])
}
